import React from 'react';
import { useTranslation } from 'react-i18next';
import { List } from '@mui/material';
import { Assignment, EmojiEvents, FitnessCenter, Group, Payment, Restaurant, SupportAgent } from '@mui/icons-material';
import { CalendarCursor, ChartBoxOutline } from 'mdi-material-ui';
import CollapsibleMenuItem from 'components/shared/menus/CollapsibleMenuItem';
import MenuItem from 'components/shared/menus/MenuItem';
import NestedMenuItem from 'components/shared/menus/NestedMenuItem';
import routes from 'common/routes';

function TrainerMoreHub() {
  const { t } = useTranslation(['routes', 'pqrs']);

  return (
    <List>
      <MenuItem
        icon={<CalendarCursor />}
        itemKey="trainerGroupSessions"
        label={t('session.groupSessions', { ns: 'routes' })}
        path={routes.trainerGroupSessions.path}
      />
      <MenuItem
        icon={<Group />}
        itemKey="client"
        label={t('client.list', { ns: 'routes' })}
        path={routes.listClient.path}
      />
      <MenuItem
        icon={<Restaurant />}
        itemKey="nutrition-admin"
        label={t('nutrition', { ns: 'routes', defaultValue: 'Programas nutricionales' })}
        path={routes.adminNutrition.path}
      />
      <MenuItem
        icon={<ChartBoxOutline />}
        itemKey="performance"
        label={t('performance.list', { ns: 'routes' })}
        path={routes.listPerformance.path}
      />
      <MenuItem
        icon={<EmojiEvents />}
        itemKey="ranking"
        label="Ranking Global"
        path={routes.globalRanking.path}
      />
      <CollapsibleMenuItem
        icon={<FitnessCenter />}
        label="Ejercicios"
        noLink>
        <NestedMenuItem
          label={t('exercise.list', { ns: 'routes' })}
          path={routes.exercises.path}
        />
        <NestedMenuItem
          label="Solicitudes"
          path={routes.exerciseRequests.path}
        />
      </CollapsibleMenuItem>
      <MenuItem
        icon={<Payment />}
        itemKey="payment"
        label={t('payment.payments', { ns: 'routes' })}
        path={routes.listTrainerPayments.trainer.path}
      />
      <MenuItem
        icon={<Assignment />}
        itemKey="legal"
        label={t('legal.list', { ns: 'routes' })}
        path={routes.viewTC.path}
      />
      <MenuItem
        icon={<SupportAgent />}
        itemKey="pqrs"
        label={t('menu', { ns: 'pqrs', defaultValue: 'Soporte (PQRS)' })}
        path={routes.myPqrs.path}
      />
    </List>
  );
}

export default TrainerMoreHub;
